import React, { useState, useEffect } from 'react';
import { ArrowLeft, Users, PlusCircle } from 'react-feather';
import { Search } from 'react-feather';
import styles from '../Writes.module.scss';
import { useNavigate } from '@reach/router';
import ImageFadeIn from 'react-image-fade-in';

import classIcon from '../../../images/classIcon.png';
import cx from 'classnames';
import * as Icon from 'react-feather';

import { useMutation } from '@apollo/react-hooks';
import { DELETE_GROUPS, RENAME_GROUP, GET_GROUPS } from '../services/graphql';
import { Modal, Button } from '@squirrellearningltd/go-teacher-components';

const ManageGroups = ({
    navigateBack,
    availableGroups,
    schoolId,
    setSelectedGroup,
}) => {
    const navigate = useNavigate();

    // Internal props
    const [searchTherm, setSearchTherm] = useState('');
    const [visibleGroups, setVisibleGroups] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showRenameGroupModal, setShowRenameGroupModal] = useState(false);
    const [groupName, setGroupname] = useState(undefined);

    // Functions
    const onSelectGroups = (e) => {
        if (selectedGroups.indexOf(e.target.value) !== -1) {
            setSelectedGroups(
                selectedGroups.filter((s) => s !== e.target.value)
            );
        } else {
            setSelectedGroups([...selectedGroups, e.target.value]);
        }
    };

    // Data handling
    const [deleteGroups, { loading: deleteProcessOngoing }] = useMutation(
        DELETE_GROUPS,
        {
            variables: {
                groupIds: selectedGroups,
            },
            onError: () => {
                setSelectedGroups([]);
                alert(
                    `The ${
                        selectedGroups.length > 1 ? 'Groups' : 'Group'
                    } could not be deleted. Please try again.`
                );
            },

            onCompleted: () => {
                setSelectedGroups([]);
                alert(
                    `${
                        selectedGroups.length > 1 ? 'Groups were' : 'Group was'
                    } successfully deleted.`
                );
            },
            refetchQueries: [
                {
                    query: GET_GROUPS,
                    variables: {
                        schoolId: schoolId,
                    },
                },
            ],
            awaitRefetchQueries: true,
        }
    );

    const [renameGroup, { loading: renameProcessOngoing }] = useMutation(
        RENAME_GROUP,
        {
            variables: {
                groupId: selectedGroups[0],
                name: groupName,
            },
            onError: () =>
                alert('The group could not be renamed. Please try again.'),
            onCompleted: () => alert('Group was successfully renamed.'),
            refetchQueries: [
                {
                    query: GET_GROUPS,
                    variables: {
                        schoolId: schoolId,
                    },
                },
            ],
            awaitRefetchQueries: true,
        }
    );

    // Effects
    useEffect(() => {
        const results = searchTherm
            ? visibleGroups.filter((visibleGroup) =>
                  visibleGroup.name
                      .toLowerCase()
                      .includes(searchTherm.toLowerCase())
              )
            : availableGroups?.getGroups
            ? availableGroups.getGroups
            : [];
        setVisibleGroups(results);
    }, [searchTherm, availableGroups]);

    return (
        <>
            <div className='page-header'>
                <div className='page-header__content'>
                    <div className='page-header__content__inner'>
                        <h2 className='page-header__content__title'>
                            <Users /> Select a Group
                        </h2>
                    </div>
                </div>
                <div className='page-header__actions'>
                    <button
                        onClick={navigateBack}
                        className='u-display-flex u-align-center u-text-dark'
                    >
                        <ArrowLeft className='u-m-right-1' /> Back
                    </button>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-4'>
                    <input
                        className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                        type='search'
                        placeholder='Search'
                        onChange={(e) => setSearchTherm(e.target.value)}
                        value={searchTherm}
                    />
                    {!searchTherm && <Search size={20} className={styles.utilitiesSearchIcon} />}
                </div>
                <div className={`${styles.manageGroupsActions} col-md-4`}>
                    <button
                        className={cx(
                            styles.classActionsLink,
                            styles.classActionsLinkIcon,
                            !selectedGroups.length || deleteProcessOngoing
                                ? styles.classActionsLinkDisabled
                                : ''
                        )}
                        onClick={() => deleteGroups()}
                    >
                        <Icon.Trash />
                        Delete Group
                    </button>
                    <button
                        className={cx(
                            styles.classActionsLink,
                            styles.classActionsLinkIcon,
                            !selectedGroups.length ||
                                selectedGroups.length > 1 ||
                                renameProcessOngoing
                                ? styles.classActionsLinkDisabled
                                : ''
                        )}
                        onClick={() => setShowRenameGroupModal(true)}
                    >
                        <Icon.Edit />
                        Rename Group
                    </button>
                </div>
            </div>
            <div className='row'>
                <div
                    className={cx('col-lg-4 col-md-6')}
                    onClick={
                        visibleGroups.length > 0
                            ? () => {
                                  navigate(
                                      `/startWrite/addStudentsToGroup/newGroup`
                                  );
                              }
                            : undefined
                    }
                >
                    <div
                        className={cx(
                            styles.createGroupCard,
                            styles.write,
                            'card',
                            visibleGroups.length > 0
                                ? 'card-hover'
                                : styles.disabled
                        )}
                    >
                        <PlusCircle className={styles.addTaskBtnIcon} />
                    </div>
                </div>
                {visibleGroups && visibleGroups.length ? (
                    visibleGroups.map((visibleGroup) => (
                        <div
                            onClick={() => {
                                setSelectedGroup(visibleGroup);
                                navigate(
                                    `/startWrite/manageGroupStudents/${visibleGroup.id}`
                                );
                            }}
                            key={visibleGroup.id}
                            className={`${styles.write} col-lg-4 col-md-6`}
                        >
                            <div className='card card-hover'>
                                <div className={styles.cardContent}>
                                    <div
                                        className={cx(
                                            'basic-form__group--check',
                                            styles.stCheck,
                                            styles.stCheckTop
                                        )}
                                    >
                                        <input
                                            name='group'
                                            className='basic-form__check-box'
                                            type='checkbox'
                                            value={visibleGroup.id}
                                            onChange={(e) => onSelectGroups(e)}
                                            checked={
                                                selectedGroups.indexOf(
                                                    visibleGroup.id
                                                ) > -1
                                            }
                                            id={`st_${visibleGroup.id}`}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        <label
                                            className='basic-form__check-label'
                                            htmlFor={`st_${visibleGroup.id}`}
                                        >
                                            &nbsp;
                                        </label>
                                    </div>

                                    <ImageFadeIn
                                        src={classIcon}
                                        alt='class-icon'
                                        className={styles.cardContentClassIcon}
                                    />
                                    <div
                                        className={styles.cardContentClassName}
                                    >
                                        {visibleGroup.name}
                                    </div>
                                    <div
                                        className={
                                            styles.cardContentAcademicYear
                                        }
                                    >
                                        {visibleGroup.description}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No availale groups.</p>
                )}
            </div>

            {showRenameGroupModal && (
                <Modal
                    closeModal={() => {
                        setShowRenameGroupModal(false);
                        setGroupname(undefined);
                    }}
                >
                    <h3>Please provide a group name</h3>
                    <input
                        type='text'
                        onChange={(e) => setGroupname(e.target.value)}
                        className='basic-form__text-box'
                    />

                    <Button
                        disabled={!groupName}
                        onClick={() => {
                            renameGroup();
                            setShowRenameGroupModal(false);
                            setGroupname(undefined);
                        }}
                    >
                        Rename Group
                    </Button>
                </Modal>
            )}
        </>
    );
};

export default ManageGroups;
